import { StatusRenderer } from "@lit/task";
import { html, nothing, TemplateResult } from "lit";

export const nothingTemplate = html`${nothing}`;



export const fallbackRenderer = <T>(renderer:StatusRenderer<T> & { default: () => TemplateResult<1> }): StatusRenderer<T> => {
  return { 
    initial: renderer.initial ?? renderer.default,
    pending: renderer.pending ?? renderer.default,
    complete:renderer.complete ?? renderer.default,
    error: renderer.error ?? renderer.default
  }
}
